module.exports = __webpack_public_path__ + "img/Avatar-45.c956f663.svg";